import { render, staticRenderFns } from "./TextMessageElement.vue?vue&type=template&id=bdd017ee&scoped=true&"
import script from "./TextMessageElement.vue?vue&type=script&lang=babel&"
export * from "./TextMessageElement.vue?vue&type=script&lang=babel&"
import style0 from "./TextMessageElement.vue?vue&type=style&index=0&id=bdd017ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd017ee",
  null
  
)

export default component.exports